/*
 * @Author: bbqin
 * @Date: 2022-11-07 14:47:52
 * @LastEditTime: 2022-11-07 17:45:35
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\components\Form\formInfoGroup.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
import React from 'react';
import { GridContainer } from '@platform/base';
import InfoGroupHeader from '../icon/infoGroupHeader';
const GridGroup = GridContainer.Group;
const GridItem = GridContainer.Item;

export default function FormInfoGroup(props) {
    let { children, groupTitle = '信息分组', groupColor, groupIcon, moduleId, colGap, rowGap, columnSpan, rowSpan, offsetColumn } = props;
    return <GridGroup className={`form-info-group-wrapper free-layout-info-group color-${groupColor}`} {...{ moduleId, colGap, rowGap, columnSpan, rowSpan, offsetColumn }}>
        <GridItem className='info-group-header-wrapper' columnSpan={12}>
            <InfoGroupHeader title={groupTitle} icon={groupIcon} color={groupColor} />
        </GridItem>
        {children}
    </GridGroup>;
}